import { KmsTypeSchedulingTimeInterval, TimeDisplay } from "@kaltura/mediaspace-shared-types";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import { translateTime } from "@kaltura/mediaspace-shared-utils";

/**
 * Format scheduling data for the session card.
 */
export const useEventListTimeFormatting = (schedulingData: KmsTypeSchedulingTimeInterval) => {
    const context = useConfig();
    const { timeDisplay, dateFormats } = context.application;

    // January 23, 2020 9:00 AM - 9:30 AM EST /12 hours || 9:00 - 09:30 EST /24 hours
    const timeFormat = timeDisplay === TimeDisplay.TwentyFourHours ? "H:mm" : "h:mm A"; // 15:00 || 3:00 PM
    const startTimeFormat = timeFormat;
    const endTimeFormat = `${timeFormat} z`;
    const formattedStartTime = translateTime(schedulingData.start.timestamp, startTimeFormat);
    const formattedEndTime = translateTime(schedulingData.end.timestamp, endTimeFormat);

    const formattedTime = formattedStartTime + " - " + formattedEndTime;
    const formattedDate = translateTime(schedulingData.start.timestamp, dateFormats.shortDate);

    return { formattedTime, formattedDate };
};
